module.exports = __webpack_public_path__ + "img/ssb_menu1.2ac21b07.png";